<template>
    <!-- 显示设置组件
        @author: liuguisheng
        @date: 2019-11-21
    -->
    <div class="setting-item">
    <el-form-item label="显示设置"> 
        <el-radio-group v-model="showRule" size="small">
          <el-radio-button v-for="(item,index) in showConfigList"
                          :key="index" 
                          :label="item.label">{{item.value}}</el-radio-button>
        </el-radio-group>
    </el-form-item>
  </div>
</template>
<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入展示配置文件
import { showConfigList } from '@/assets/js/config_dictionary.js';
export default {
  mixins: [ mixValueWatch ],
  data () {
    return {
      // 显示设置配置
      showConfigList
    }
  },
  computed: {
    /** @name 显示设置
     *  @description 将 showRule 字段映射到当前 showRule 计算属性
     *  @return { Object }
     *  @author liuguisheng
     *  @version 2019-11-21
     */
    ...mapComputed({
      showRule: { 
        parent: i => i.renderOption,
        attr: "showRule"
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderShow.vue